<template>
  <div>
    <div class="head-warp">
      <div :class="[isPut ? '' : 'is-put', 'case-search-condition-content']">
        <lawSearchInfo :list="conditionList" remove @removeFilter="removeFilter">
          <div slot="right-float" class="sort word-normal sort-wrap">
            <template v-if="lawTotal > -1 && !showAll">
              <span>共查询到</span>
              <span :style="{ color: '#E6A23C' }">{{ lawTotal }}</span>
              <span :style="{ marginRight: '10px' }">篇法规</span>
            </template>
            <span>排序 ：</span>
            <el-dropdown>
              <span class="el-dropdown-link word-normal">
                <span>
                  <span>{{ sortValue }}</span>
                  <span><i class="el-icon-caret-bottom"></i></span>
                </span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="sortRes('', '', '默认排序')">默认排序</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="sortRes('pubQueryTime', 'asc', '发布日期升序')">发布日期升序</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="sortRes('pubQueryTime', 'desc', '发布日期降序')">发布日期降序</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="sortRes('execQueryTime', 'asc', '实施日期升序')">实施日期升序</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="sortRes('execQueryTime', 'desc', '实施日期降序')">实施日期降序</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </lawSearchInfo>
      </div>
      <!-- <div class="case-search-put"></div>
        <div class="put-text" @click="isPut = !isPut">{{ isPut ? '收起' : '展开' }}</div> -->
    </div>

    <div class="home-container" ref="homeContainerRef">
      <div class="result-body" ref="resultBody" v-if="!expiredModal.show && resultList.length > 0 && isload">
        <div
          class="knowledge"
          v-if="plumbJson.data.children && plumbJson.data.children.length > 0"
          :class="hideOverMind ? 'hideOverMind' : ''"
        >
          <div class="title">
            <div class="knowledge-top">
              <span>词条知识图谱</span>
              <a @click="openAllScreen" class="word-middle">全屏</a>
              <!-- <span class="word-small tip"><i class="el-icon-question"></i></span>
                            <span class="word-small tip">知识图谱的内容可点击查看</span> -->
            </div>
          </div>

          <div
            id="xbgLawMin"
            @click="mindControl"
            v-if="showMind && plumbJson.data.children && plumbJson.data.children.length > 0"
          ></div>

          <div class="open-all" @click="hideOverMind = !hideOverMind" :style="hideOverMind ? 'bottom:12px;' : ''">
            <span v-if="!hideOverMind" class="word-normal word-color2">展开知识图谱</span>
            <span v-else class="word-normal word-color2">收起知识图谱</span>
            <span><i class="el-icon-arrow-down"></i></span>
          </div>
        </div>

        <div class="search-panel" v-if="resultList.length > 0">
          <div class="the-result-body" v-if="!showAll">
            <div class="all-category">
              <el-tabs v-model="activeTab" class="sticky-tab" @tab-click="handleTab">
                <el-tab-pane v-for="(item, index) in tabList" :label="item.label" :name="item.label" :key="index">
                  {{ item.label }}
                </el-tab-pane>
              </el-tabs>

              <div
                v-for="(category, index) in resultList"
                :key="index"
                class="half-line"
                :ref="category.f0"
                style="padding: 0 30px 30px 30px"
              >
                <div class="item-title">
                  <span class="name">{{ category.f0 }}</span>
                  <span class="word-small">({{ category.f1.f3 }})</span>
                </div>
                <div v-for="(item, index) in category.f1.f1" :key="index" class="cate-list" @click="goAggDetail(item)">
                  <div class="search-panel-title">
                    <span class="title-name" style="font-weight:bold" v-html="item.title"></span>
                    <span
                      class="timeline word-small"
                      v-if="item.status"
                      :style="item.status == '失效' ? 'border-color:#999999;color:#999999;' : ''"
                      >{{ item.status }}</span
                    >
                    <span class="timeline word-small collect_status" v-if="item.collect_status">{{
                      item.collect_status
                    }}</span>
                  </div>
                  <lawStatusTag :item="item" />
                  <div v-if="item.f2 && item.f2.length > 1" @click.stop="">
                    <el-tabs v-model="item.activeLaw" class="samelaw-tab" @tab-click="handleSameTab(item)">
                      <el-tab-pane
                        v-for="(ele, index) in item.f2"
                        :label="ele.title.replace('中华人民共和国', '').replace(/<\/?[^>]*>/g, '')"
                        :name="ele.id"
                        :key="index"
                      >
                        <div class="search-panel-content" v-if="ele.paragraphs.length > 0">
                          <div class="is-law" style="margin-top:0" v-if="ele.level == '法律'">
                            <div
                              v-for="(paragraph, index) in ele.paragraphs"
                              :key="index"
                              @click.stop="goLaw(paragraph)"
                              class="the-paragraph"
                              v-if="paragraph.title || paragraph.source"
                              :style="index == ele.paragraphs.length - 1 ? 'border:none' : ''"
                            >
                              <div
                                class="paragraph-head"
                                v-if="paragraph.type !== '章' && paragraph.type !== '节' && paragraph.type !== '编'"
                              >
                                <div
                                  class="paragraph-name word-normal"
                                  style="font-weight:bold"
                                  v-html="paragraph.title"
                                ></div>
                                <span class="paragraph-head-icon" @click.stop="openContent(paragraph)">
                                  <i
                                    :style="paragraph.showContent ? 'transform: rotate(-180deg)' : ''"
                                    class="el-icon-arrow-down"
                                  ></i>
                                </span>
                              </div>

                              <div v-else class="paragraph-head" @click.stop="goBook(item.cid, paragraph)">
                                <div
                                  class="paragraph-name word-normal"
                                  style="font-weight:bold"
                                  v-html="paragraph.title"
                                ></div>
                                <span class="word-normal" style="color:#4A90E2">进入整{{ paragraph.type }}</span>
                              </div>

                              <div
                                class="paragraph-desc word-color1 word-normal"
                                v-show="
                                  paragraph.showContent &&
                                    paragraph.type !== '章' &&
                                    paragraph.type !== '节' &&
                                    paragraph.type !== '编'
                                "
                                :style="paragraph.showContent && paragraph.source ? 'margin-top:10px;' : ''"
                                v-html="
                                  '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                    enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                                "
                              ></div>
                            </div>
                          </div>
                          <div class="is-law" v-if="ele.level !== '法律'">
                            <div
                              v-for="(paragraph, index) in ele.paragraphs"
                              :key="index"
                              class="the-paragraph"
                              :style="index == ele.paragraphs.length - 1 ? 'border:none' : ''"
                              v-if="paragraph.source"
                            >
                              <div
                                class="paragraph-desc word-color1 word-normal"
                                v-html="
                                  '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                    enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                                "
                              ></div>
                            </div>
                          </div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>

                  <div v-if="item.f2 && item.f2.length == 1">
                    <div class="search-panel-content" v-if="item.f2[0].paragraphs.length > 0">
                      <div class="is-law" v-if="item.f2[0].level == '法律'">
                        <div
                          v-for="(paragraph, index) in item.f2[0].paragraphs"
                          :key="index"
                          @click.stop="goLaw(paragraph)"
                          class="the-paragraph"
                          :style="index == item.f2[0].paragraphs.length - 1 ? 'border:none' : ''"
                        >
                          <div v-if="paragraph.title">
                            <div
                              class="paragraph-head"
                              v-if="paragraph.type !== '章' && paragraph.type !== '节' && paragraph.type !== '编'"
                            >
                              <div
                                class="paragraph-name word-normal"
                                style="font-weight:bold"
                                v-html="paragraph.title"
                              ></div>
                              <span class="paragraph-head-icon" @click.stop="openContent(paragraph)">
                                <i
                                  :style="paragraph.showContent ? 'transform: rotate(-180deg)' : ''"
                                  class="el-icon-arrow-down"
                                ></i>
                              </span>
                            </div>

                            <div v-else class="paragraph-head" @click.stop="goBook(item.cid, paragraph)">
                              <div
                                class="paragraph-name word-normal"
                                style="font-weight:bold"
                                v-html="paragraph.title"
                              ></div>
                              <span class="word-normal" style="color:#4A90E2">进入整{{ paragraph.type }}</span>
                            </div>

                            <div
                              class="paragraph-desc word-color1 word-normal"
                              v-show="
                                paragraph.showContent &&
                                  paragraph.type !== '章' &&
                                  paragraph.type !== '节' &&
                                  paragraph.type !== '编'
                              "
                              :style="paragraph.showContent && paragraph.source ? 'margin-top:10px;' : ''"
                              v-html="
                                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                              "
                            ></div>
                          </div>
                          <div v-else>
                            <div
                              class="paragraph-desc word-color1 word-normal"
                              v-show="
                                paragraph.showContent &&
                                  paragraph.type !== '章' &&
                                  paragraph.type !== '节' &&
                                  paragraph.type !== '编'
                              "
                              :style="paragraph.showContent && paragraph.source ? 'margin-top:10px;' : ''"
                              v-html="
                                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + enterLine(removeSpace(paragraph.source))
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div class="is-law" v-if="item.f2[0].level !== '法律'">
                        <div
                          v-for="(paragraph, index) in item.f2[0].paragraphs"
                          :key="index"
                          class="the-paragraph"
                          :style="index == item.f2[0].paragraphs.length - 1 ? 'border:none' : ''"
                          v-if="paragraph.source"
                        >
                          <div
                            class="paragraph-desc word-color1 word-normal"
                            v-html="
                              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="word-middle look-more" @click="showAllRes(category, index)" v-if="category.f1.f0 > 3">
                  查看更多({{ category.f1.f3 }})
                </div>
              </div>
            </div>
          </div>

          <div class="the-result-body" v-if="showAll">
            <div class="all-result-panel">
              <div class="all-result fixed-css">
                <div class="all-result-left">
                  <div @click="backToList">
                    <span class="icon-middle back-icon">
                      <img src="../../assets/default-back.png" alt="" />
                    </span>
                    <span class="icon-middle cur-back-icon">
                      <img src="../../assets/cur-back.png" alt="" />
                    </span>
                    <span class="word-color1 word-big back back-to">回到全部结果</span>
                  </div>
                  <span style="margin:0 5px;"><i class="el-icon-arrow-right"></i></span>
                  <div>
                    <span class="word-color3 word-big back">{{ listType }}</span>
                    <span class="word-middle word-color3">(共{{ categoryTotal }}条)</span>
                  </div>
                </div>
              </div>

              <div class="all-list">
                <!-- <div class="all-list-item" v-for="(item,index) in categories" :key="index" @click="goAggDetail(item)">
                                    <div class="search-panel-title">
                                        <span class="title-name word-big" style="font-weight:bold"
                                            v-html="setHighlight(item.title,terms)"></span>
                                        <span class="timeline word-small" :style="item.status == '失效'?'border-color:#999999;color:#999999;':''">{{item.status}}</span>
                                    </div>
                                    <div class="status-bar">
                                        <span class="tag-status" v-if="item.level">{{item.level}}</span>
                                        <span class="tag-status" v-if="item.publishMachinery">{{item.publishMachinery.join('/')}}</span>
                                        
                                        <span class="tag-status" v-if="item.docNum">{{item.docNum}}</span>
                                        <span class="tag-status" v-if="item.execTime">实施时间{{item.execTime}}</span>
                                        <span class="tag-status" v-if="item.pubTime">发布时间{{item.pubTime}}</span>
                                    </div>
                                    <div class="search-panel-content" v-if="item.paragraphs.length>0">
                                        <div class="is-law" v-if="item.level == '法律'"
                                        :style="item.autoHeight?'max-height:2000px;':''">
                                            <div v-for="(paragraph,index) in item.paragraphs" :key="index" @click="goLaw(paragraph)" :style="index==item.paragraphs.length-1?'border:none':''" class="the-paragraph" v-if="paragraph.title">
                                                <div class="paragraph-head" v-if="paragraph.type!=='章' && paragraph.type!=='节' && paragraph.type!=='编'">
                                                    <div class="paragraph-name word-normal" style="font-weight:bold" v-html="paragraph.title">
                                                    </div>
                                                    <span class="paragraph-head-icon" @click.stop="openContent(paragraph)">
                                                        <i :style="paragraph.showContent?'transform: rotate(-180deg)':''" class="el-icon-arrow-down"></i>
                                                    </span>
                                                </div>
                                                <div v-else class="paragraph-head" @click.stop="goBook(item.cid,paragraph)">
                                                    <div class="paragraph-name word-normal" style="font-weight:bold" v-html="paragraph.title">
                                                    </div>
                                                    <span class="word-normal" style="color:#4A90E2">进入整{{paragraph.type}}</span>
                                                </div>
                                                <div class="paragraph-desc word-color1 word-normal"
                                                    v-show="paragraph.showContent && paragraph.type!=='章' && paragraph.type!=='节' && paragraph.type!=='编'"
                                                    :style="paragraph.showContent && paragraph.source?'margin-top:10px;':''"
                                                    v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +  enterLine(removeSpace(paragraph.source,paragraph.title),terms)"></div>
                                            </div>
                                        </div>

                                        <div class="is-law" v-if="item.level !== '法律'">
                                            <div v-for="(paragraph,index) in item.paragraphs" :key="index"
                                            class="the-paragraph" :style="index==item.paragraphs.length-1?'border:none':''" v-if="paragraph.source">
                                                <div class="paragraph-desc word-color1 word-normal" v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + enterLine(removeSpace(paragraph.source,paragraph.title),terms)"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                <div v-for="(item, index) in categories" :key="index" class="cate-list" @click="goAggDetail(item)">
                  <div class="search-panel-title">
                    <span class="title-name" style="font-weight:bold" v-html="item.title"></span>
                    <span
                      class="timeline word-small"
                      v-if="item.status"
                      :style="item.status == '失效' ? 'border-color:#999999;color:#999999;' : ''"
                      >{{ item.status }}</span
                    >
                    <span class="timeline word-small collect_status" v-if="item.collect_status">{{
                      item.collect_status
                    }}</span>
                  </div>
                  <lawStatusTag :item="item" />
                  <div v-if="item.f2 && item.f2.length > 1" @click.stop="">
                    <el-tabs v-model="item.activeLaw" class="samelaw-tab" @tab-click="handleSameTab(item)">
                      <el-tab-pane
                        v-for="(ele, index) in item.f2"
                        :label="ele.title.replace('中华人民共和国', '').replace(/<\/?[^>]*>/g, '')"
                        :name="ele.id"
                        :key="index"
                      >
                        <div class="search-panel-content" v-if="ele.paragraphs.length > 0">
                          <div class="is-law" style="margin-top:0" v-if="ele.level == '法律'">
                            <div
                              v-for="(paragraph, index) in ele.paragraphs"
                              :key="index"
                              @click.stop="goLaw(paragraph)"
                              class="the-paragraph"
                              v-if="paragraph.title || paragraph.source"
                              :style="index == ele.paragraphs.length - 1 ? 'border:none' : ''"
                            >
                              <div
                                class="paragraph-head"
                                v-if="paragraph.type !== '章' && paragraph.type !== '节' && paragraph.type !== '编'"
                              >
                                <div
                                  class="paragraph-name word-normal"
                                  style="font-weight:bold"
                                  v-html="paragraph.title"
                                ></div>
                                <span class="paragraph-head-icon" @click.stop="openContent(paragraph)">
                                  <i
                                    :style="paragraph.showContent ? 'transform: rotate(-180deg)' : ''"
                                    class="el-icon-arrow-down"
                                  ></i>
                                </span>
                              </div>

                              <div v-else class="paragraph-head" @click.stop="goBook(item.cid, paragraph)">
                                <div
                                  class="paragraph-name word-normal"
                                  style="font-weight:bold"
                                  v-html="paragraph.title"
                                ></div>
                                <span class="word-normal" style="color:#4A90E2">进入整{{ paragraph.type }}</span>
                              </div>

                              <div
                                class="paragraph-desc word-color1 word-normal"
                                v-show="
                                  paragraph.showContent &&
                                    paragraph.type !== '章' &&
                                    paragraph.type !== '节' &&
                                    paragraph.type !== '编'
                                "
                                :style="paragraph.showContent && paragraph.source ? 'margin-top:10px;' : ''"
                                v-html="
                                  '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                    enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                                "
                              ></div>
                            </div>
                          </div>
                          <div class="is-law" v-if="ele.level !== '法律'">
                            <div
                              v-for="(paragraph, index) in ele.paragraphs"
                              :key="index"
                              class="the-paragraph"
                              :style="index == ele.paragraphs.length - 1 ? 'border:none' : ''"
                              v-if="paragraph.source"
                            >
                              <div
                                class="paragraph-desc word-color1 word-normal"
                                v-html="
                                  '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                    enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                                "
                              ></div>
                            </div>
                          </div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>

                  <div v-if="item.f2 && item.f2.length == 1">
                    <div class="search-panel-content" v-if="item.f2[0].paragraphs.length > 0">
                      <div class="is-law" v-if="item.f2[0].level == '法律'">
                        <div
                          v-for="(paragraph, index) in item.f2[0].paragraphs"
                          :key="index"
                          @click.stop="goLaw(paragraph)"
                          class="the-paragraph"
                          :style="index == item.f2[0].paragraphs.length - 1 ? 'border:none' : ''"
                        >
                          <div v-if="paragraph.title">
                            <div
                              class="paragraph-head"
                              v-if="paragraph.type !== '章' && paragraph.type !== '节' && paragraph.type !== '编'"
                            >
                              <div
                                class="paragraph-name word-normal"
                                style="font-weight:bold"
                                v-html="paragraph.title"
                              ></div>
                              <span class="paragraph-head-icon" @click.stop="openContent(paragraph)">
                                <i
                                  :style="paragraph.showContent ? 'transform: rotate(-180deg)' : ''"
                                  class="el-icon-arrow-down"
                                ></i>
                              </span>
                            </div>

                            <div v-else class="paragraph-head" @click.stop="goBook(item.cid, paragraph)">
                              <div
                                class="paragraph-name word-normal"
                                style="font-weight:bold"
                                v-html="paragraph.title"
                              ></div>
                              <span class="word-normal" style="color:#4A90E2">进入整{{ paragraph.type }}</span>
                            </div>

                            <div
                              class="paragraph-desc word-color1 word-normal"
                              v-show="
                                paragraph.showContent &&
                                  paragraph.type !== '章' &&
                                  paragraph.type !== '节' &&
                                  paragraph.type !== '编'
                              "
                              :style="paragraph.showContent && paragraph.source ? 'margin-top:10px;' : ''"
                              v-html="
                                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                              "
                            ></div>
                          </div>

                          <div v-else>
                            <div
                              class="paragraph-desc word-color1 word-normal"
                              v-show="
                                paragraph.showContent &&
                                  paragraph.type !== '章' &&
                                  paragraph.type !== '节' &&
                                  paragraph.type !== '编'
                              "
                              :style="paragraph.showContent && paragraph.source ? 'margin-top:10px;' : ''"
                              v-html="
                                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + enterLine(removeSpace(paragraph.source))
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div class="is-law" v-if="item.f2[0].level !== '法律'">
                        <div
                          v-for="(paragraph, index) in item.f2[0].paragraphs"
                          :key="index"
                          class="the-paragraph"
                          :style="index == item.f2[0].paragraphs.length - 1 ? 'border:none' : ''"
                          v-if="paragraph.source"
                        >
                          <div
                            class="paragraph-desc word-color1 word-normal"
                            v-html="
                              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                enterLine(removeSpace(paragraph.source, paragraph.title), terms)
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="paginate-bar" v-if="totalPage > 15">
                  <el-pagination
                    background
                    layout="pager, next"
                    :current-page.sync="topHitsPage"
                    :total="totalPage > 150 ? 150 : totalPage"
                    :page-size="15"
                    @current-change="loadMore"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="result-no-data" v-if="resultList.length == 0 && isload">
        <img src="../../assets/状态图标/no_result.png" />
      </div>

      <!-- 右侧筛选树 -->
      <div class="menu" :class="{ menufixed: menuFlag }" v-if="!expiredModal.show && resultList.length > 0 && isload">
        <template>
          <div class="tree-item" v-for="(item, index) in treeSectionList" v-if="item.list.length > 0" :key="index">
            <div class="filter-tree-head" @click="item.showContent = !item.showContent">
              <p class="word-middle">{{ item.name }}</p>
              <span><i class="el-icon-caret-bottom"></i></span>
            </div>
            <collapse-transition>
              <div v-if="item.showContent" class="level-two">
                <el-tree
                  class="custom-tree"
                  :data="item.showMore ? item.list : item.list.slice(0, 4)"
                  :props="{ label: 'name' }"
                  @node-click="e => setCondition(item.key, e)"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ data.name }} ({{ data.doc_count }})</span>
                  </span>
                </el-tree>
                <div class="show-more word-smaller" v-if="item.list.length > 4 && !item.showAll">
                  <span class="word-normal" v-if="item.showMore" @click="item.showMore = false">收起</span>
                  <span class="open-tip" v-else @click="item.showMore = true">
                    <i class="word-middle el-icon-arrow-down"></i>
                    <a class="word-normal">展开</a>
                  </span>
                </div>
              </div>
            </collapse-transition>
          </div>
        </template>
      </div>

      <el-dialog title="知识图谱" :visible.sync="allScreen" :fullscreen="true" custom-class="knowledge-dialog" center>
        <div v-if="allScreen" id="xbgLawFullMind" @click="mindFullControl"></div>
      </el-dialog>

      <vipCreator
        v-if="expiredModal.show"
        :show.sync="expiredModal.show"
        :limitType="expiredModal.limitType"
        vipType="law"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import jsMind from 'jsmind';
import graphChart from '../../components/echart/graphChart';
import CollapseTransition from '../../components/transition';
import { sliceStr, setHighlight, removeSpace, enterLine } from '../../filter';
import publicUtilFunc from '@/common/js/publicUtil';
import vipCreator from '@/components/vipCreator';
import { usedLimitErrCode, projectInfoConfig } from '@/constant';
import { services } from '@/service';
import lawSearchInfo from '@/components/lawSearchInfo.vue';
import lawStatusTag from '@/components/lawStatusTag.vue';

const publicUtil = publicUtilFunc();

let arrayToTree = sNodes => {
  let i,
    l,
    key = 'id',
    parentKey = 'parentId',
    childKey = 'children';
  if (!key || key == '' || !sNodes) return [];

  if (sNodes instanceof Array) {
    var r = [];
    var tmpMap = [];
    for (i = 0, l = sNodes.length; i < l; i++) {
      tmpMap[sNodes[i][key]] = sNodes[i];
    }
    for (i = 0, l = sNodes.length; i < l; i++) {
      sNodes[i].topic = sNodes[i].name.replace('中华人民共和国', '');
      sNodes[i]['background-color'] = '#50C1F9';
      sNodes[i]['foreground-color'] = '#FFFFFF';
      if (tmpMap[sNodes[i][parentKey]] && sNodes[i][key] != sNodes[i][parentKey]) {
        if (!tmpMap[sNodes[i][parentKey]][childKey]) tmpMap[sNodes[i][parentKey]][childKey] = [];
        tmpMap[sNodes[i][parentKey]][childKey].push(sNodes[i]);
      } else {
        r.push(sNodes[i]);
      }
    }
    return r;
  } else {
    return [sNodes];
  }
};
export default {
  data() {
    return {
      isPut: true,
      resultList: [],
      categories: [],
      tabList: [],
      categoryName: '',
      levelName: '',
      lawName: '',
      searchKey: '',
      currentPage: 1,
      totalPage: '',
      categoryTotal: '',
      topHitsSize: 3,
      topHitsPage: 1,
      isload: false,
      jMmodel: {},
      orginalLaws: [],
      lawList: [],
      status: '',
      category: '',
      publishMachinery: '',
      section: '',
      pubYear: '',
      terms: [],
      activeTab: '综合',
      showAll: false,
      sortValue: '默认排序',
      listType: '',
      sortField: '',
      sortType: '',
      fixedTab: false,
      plumbJson: {
        /* 元数据，定义思维导图的名称、作者、版本等信息 */
        meta: {
          name: 'jsMind-tree',
          author: 'zc',
          version: '1.0'
        },
        /* 数据格式声明 */
        format: 'node_tree',
        data: {}
      },
      poistionBody: {
        法律: true,
        司法解释: true,
        行政法规: true,
        部门规章: true
      },
      colors: ['#50C1F9', '#AED582', '#F6C24C', '#70D0E6', '#8D9BE8', '#F48FB1', '#63BEB5', '#EF7B57'],
      showMind: true,
      hideOverMind: false,
      tabOffsetH: 0,
      allScreen: false,
      menuFlag: false,
      lawTotal: -1,
      scrolling: false,
      scrollingController: 0,
      expiredModal: {
        show: false,
        limitType: ''
      },
      publishMachineryNull: false,
      treeSectionList: [
        {
          name: '效力级别',
          key: 'category',
          list: [],
          showMore: false,
          showContent: true
        },
        {
          name: '立法资料类别',
          key: 'classification',
          list: [],
          showMore: false,
          showContent: true
        },
        {
          name: '时效性',
          key: 'status',
          list: [],
          showMore: true,
          showContent: true,
          showAll: true
        },
        {
          name: '发布机关',
          key: 'publishMachinery',
          list: [],
          showMore: false,
          showContent: true
        },
        {
          name: '发布年份',
          key: 'PubTime',
          list: [],
          showMore: false,
          showContent: true
        },
        {
          name: '征集状态',
          key: 'collect_status',
          list: [],
          showMore: false,
          showContent: true
        }
      ],
      conditionList: []
    };
  },
  computed: {},
  components: { graphChart, 'collapse-transition': CollapseTransition, vipCreator, lawSearchInfo, lawStatusTag },
  // watch: {
  //     "$route.param": {
  //         handler: function (val) {
  //             if (val) {
  //                 this.resultList = [];

  //                 this.fetchData();
  //             }
  //         },
  //         deep: true
  //     }
  // },

  created() {
    this.upgradeTabDisabledHandle = _.debounce(this.upgradeTabDisabledHandle.bind(this), 500);
    window.addEventListener('click', this.tapHandle);
    window.addEventListener('scroll', this.pageScrollHandle);
  },

  mounted() {
    this.resultList = [];
    let _this = this;

    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    if (this.$route.query.pubYear) {
      this.pubYear = this.$route.query.pubYear;
    }
    if (this.$route.query.categoryName) {
      this.categoryName = this.$route.query.categoryName;
    }
    if (this.$route.query.levelName) {
      this.levelName = this.$route.query.levelName;
    }
    if (this.$route.query.lawName) {
      this.lawName = this.$route.query.lawName;
    }
    if (this.$route.query.publishMachinery) {
      this.publishMachinery = this.$route.query.publishMachinery;
    }
    if (this.$route.query.section) {
      this.section = this.$route.query.section;
    }
    if (this.$route.query.category) {
      this.activeTab = this.$route.query.category;
      this.showAll = true;
      this.sortField = '';
      this.sortType = '';
      this.listType = this.$route.query.category;
      window.scrollTo(0, 0);
      if (sessionStorage.getItem('topHitsPage')) {
        this.topHitsPage = sessionStorage.getItem('topHitsPage');
      }
      this.getCategary();
    }

    this.initConditionList();
    if (this.$route.name == 'lawHome') {
      this.fetchData(true);
    }
  },

  methods: {
    handleNodeClick(e) {
      console.log(e);
    },
    tapHandle(event) {
      const { className } = event.target;
      if (className.includes('el-tabs__nav-prev') || className.includes('el-tabs__nav-next')) {
        this.upgradeTabDisabledHandle();
        if (className.includes('is-disabled')) {
          this.$message.warning('已滚动至边缘部位');
        }
      }
    },
    upgradeTabDisabledHandle() {
      const [prevItem, nextItem, scrollContent] = [
        document.getElementsByClassName('el-tabs__nav-prev')[0],
        document.getElementsByClassName('el-tabs__nav-next')[0],
        document.getElementsByClassName('el-tabs__nav-scroll')[0]
      ];

      if (!prevItem || !nextItem) {
        return;
      }
      let transformVal = scrollContent.childNodes[0].style.transform.match(/\d+/);
      if (transformVal) {
        transformVal = transformVal[0];
      }
      if (!transformVal) {
        return;
      }
      transformVal = Number(transformVal);
      if (transformVal === 0) {
        prevItem.className = [...new Set(prevItem.className.split(' ').concat('is-disabled'))].join(' ');
        nextItem.className = nextItem.className
          .split(' ')
          .filter(str => str !== 'is-disabled')
          .join(' ');
      } else if (scrollContent.clientWidth + transformVal === scrollContent.childNodes[0].clientWidth) {
        prevItem.className = prevItem.className
          .split(' ')
          .filter(str => str !== 'is-disabled')
          .join(' ');
        nextItem.className = [...new Set(nextItem.className.split(' ').concat('is-disabled'))].join(' ');
      } else {
        prevItem.className = prevItem.className
          .split(' ')
          .filter(str => str !== 'is-disabled')
          .join(' ');
        nextItem.className = nextItem.className
          .split(' ')
          .filter(str => str !== 'is-disabled')
          .join(' ');
      }
    },
    initConditionList() {
      const lawOptionFilterList = JSON.parse(sessionStorage.getItem('lawOptionFilterList') || '[]');
      this.conditionList = publicUtil.getLawTagList(lawOptionFilterList);
      if (this.$route.path === '/law/home' && this.conditionList.length < 1) {
        this.$router.push('/main/search');
        throw new Error('法规空条件，跳转搜索页');
      }
    },
    removeFilter(item = {}) {
      const lawOptionFilterList = JSON.parse(sessionStorage.getItem('lawOptionFilterList')) || [];
      const curItem = lawOptionFilterList.find(curItem => item.key == curItem.key);
      if (curItem) {
        const { type, value } = curItem;
        if (type === 'string') {
          curItem.value = value
            .split(' ')
            .filter(o => o !== item.value)
            .join(' ');
        } else if (type === 'array') {
          curItem.value = value.filter(o => o !== item.value);
        } else if (type === 'array-tree') {
          curItem.value = value.filter(o => o.id !== item.id);
        } else if (type === 'date') {
          curItem.value = [];
        }
      }
      sessionStorage.setItem('lawOptionFilterList', JSON.stringify(lawOptionFilterList));
      this.initConditionList();
      this.fetchData(true);
      if (this.showAll) this.getCategary();
    },
    enterLine: enterLine,
    loadMore(page) {
      this.topHitsPage = page;
      sessionStorage.setItem('topHitsPage', this.topHitsPage);
      this.getCategary(true);
    },
    goBook(id, paragraph) {
      this.openBlankPage('fulltext', {
        id: id,
        paragraph: paragraph.id
      });
    },
    clearAll() {
      this.status = '';
      this.categoryName = '';
      this.levelName = '';
      this.publishMachinery = '';
      this.section = '';
      this.pubYear = '';
      this.lawName = '';

      var paramObj = {
        searchType: this.category,
        param: this.$route.query.param
      };
      this.$router.push({
        path: '/law/home',
        query: paramObj
      });
      this.fetchData(true);
    },
    pageScrollHandle(event) {
      this.upgradeTabDisabledHandle();
      if (this.scrolling) {
        return;
      }
      const target = event.target;
      if (target.nodeName !== '#document') {
        return;
      }
      const categoryNodes = [...document.getElementsByClassName('half-line')];
      const idx = categoryNodes.findIndex(nodeItem => {
        const { y, height } = nodeItem.getBoundingClientRect();
        if (y > 0) {
          return true;
        }
        return 110 - y < height;
      });
      if (idx !== -1) {
        this.activeTab = this.tabList[idx].label;
        var queryList = { ...this.$route.query };
        if (this.activeTab !== queryList.activeTab) {
          queryList.activeTab = this.activeTab;
          // this.$router.push({ path: '/law/home', query: queryList });
        }
      }
    },
    handleTab() {
      this.$nextTick(function() {
        this.scrolling = true;
        if (this.scrollingController) {
          clearTimeout(this.scrollingController);
        }
        this.scrollingController = setTimeout(() => (this.scrolling = false), 500);
        var heightToScroll = 0;
        if (this.$refs[this.activeTab] && this.$refs[this.activeTab][0]) {
          heightToScroll = $('html,body').scrollTop() + this.$refs[this.activeTab][0].getBoundingClientRect().top - 127;
        }
        $('html,body').animate(
          {
            scrollTop: heightToScroll
          },
          400
        );
        // var paramStr = JSON.stringify(this.$route.query);
        // var paramObj = JSON.parse(paramStr)
        // paramObj.activeTab = this.activeTab;
        // this.$router.push({
        //     path: '/law/home',
        //     query: paramObj
        // })
      });
    },
    open(item) {
      item.autoHeight = !item.autoHeight;
    },
    mindControl(event) {
      var openModel = this.jMmodel.get_selected_node();
      if (openModel) {
        if (openModel.topic == '展开<span class="el-icon-circle-plus-outline"></span>') {
          this.updateNode('展开', '收起<span class="el-icon-remove-outline"></span>');
          this.orginalLaws.forEach((v, i) => {
            if (i > 3) {
              this.appendNode(openModel.parent, v.id, v.topic, {
                'foreground-color': '#fff',
                'background-color': '#50C1F9'
              });

              v.children &&
                v.children.forEach(ele => {
                  this.appendNode(this.jMmodel.get_node(v.id), ele.id, ele.topic, {
                    'foreground-color': '#fff',
                    'background-color': '#50C1F9'
                  });
                  this.jMmodel.collapse_node(this.jMmodel.get_node(v.id));
                  ele.children &&
                    ele.children.forEach(val => {
                      this.appendNode(this.jMmodel.get_node(ele.id), val.id, val.topic, {
                        'foreground-color': '#fff',
                        'background-color': '#50C1F9'
                      });
                      this.jMmodel.collapse_node(this.jMmodel.get_node(ele.id));
                    });
                });
            }
          });
        } else if (openModel.topic == '收起<span class="el-icon-remove-outline"></span>') {
          this.updateNode('展开', '展开<span class="el-icon-circle-plus-outline"></span>');
          this.orginalLaws.forEach((v, i) => {
            if (i > 3) {
              this.removeNode(this.jMmodel.get_node(v.id));
            }
          });
        } else {
          if (event.srcElement.nodeName !== 'JMEXPANDER') {
            services.logger.handleLog({ operateName: '查看知识图谱' }, '法规');
            if (openModel.id.indexOf('xbg') !== -1) {
              if (openModel.id.indexOf('tiao') !== -1) {
                this.openBlankPage('clause', {
                  id: openModel.id
                });
              } else {
                if (openModel.id.indexOf('_') !== -1) {
                  var bookId = openModel.id.slice(0, openModel.id.indexOf('_'));
                  this.openBlankPage('fulltext', {
                    id: bookId,
                    paragraph: openModel.id
                  });
                } else {
                  this.openBlankPage('fulltext', {
                    id: openModel.id
                  });
                }
              }
            } else {
              if (openModel.topic.indexOf('(') !== -1) {
                this.activeTab = openModel.id;
                this.handleTab();
                // this.setCondition('categoryName', openModel.id);
              }
            }
          }
        }

        this.$nextTick(() => {
          this.jMmodel.select_clear();
        });
      }
    },
    mindFullControl(event) {
      var openModel = this.jMFullmodel.get_selected_node();
      if (openModel) {
        if (openModel.topic == '展开<span class="el-icon-circle-plus-outline"></span>') {
          this.updateFullNode('展开', '收起<span class="el-icon-remove-outline"></span>');
          this.orginalLaws.forEach((v, i) => {
            if (i > 3) {
              this.appendFullNode(openModel.parent, v.id, v.topic, {
                'foreground-color': '#fff',
                'background-color': '#50C1F9'
              });

              v.children &&
                v.children.forEach(ele => {
                  this.appendFullNode(this.jMFullmodel.get_node(v.id), ele.id, ele.topic, {
                    'foreground-color': '#fff',
                    'background-color': '#50C1F9'
                  });
                  this.jMFullmodel.collapse_node(this.jMFullmodel.get_node(v.id));
                  ele.children &&
                    ele.children.forEach(val => {
                      this.appendFullNode(this.jMFullmodel.get_node(ele.id), val.id, val.topic, {
                        'foreground-color': '#fff',
                        'background-color': '#50C1F9'
                      });
                      this.jMFullmodel.collapse_node(this.jMFullmodel.get_node(ele.id));
                    });
                });
            }
          });
        } else if (openModel.topic == '收起<span class="el-icon-remove-outline"></span>') {
          this.updateFullNode('展开', '展开<span class="el-icon-circle-plus-outline"></span>');
          this.orginalLaws.forEach((v, i) => {
            if (i > 3) {
              this.removeFullNode(this.jMFullmodel.get_node(v.id));
            }
          });
        } else {
          if (event.srcElement.nodeName !== 'JMEXPANDER') {
            this.allScreen = false;
            if (openModel.id.indexOf('xbg') !== -1) {
              if (openModel.id.indexOf('tiao') !== -1) {
                this.openBlankPage('clause', {
                  id: openModel.id
                });
              } else {
                if (openModel.id.indexOf('_') !== -1) {
                  var bookId = openModel.id.slice(0, openModel.id.indexOf('_'));
                  this.openBlankPage('fulltext', {
                    id: bookId,
                    paragraph: openModel.id
                  });
                } else {
                  this.openBlankPage('fulltext', {
                    id: openModel.id
                  });
                }
              }
            } else {
              if (openModel.topic.indexOf('(') !== -1) {
                this.setCondition('categoryName', openModel.id);
              }
            }
          }
        }

        this.$nextTick(() => {
          this.jMFullmodel.select_clear();
        });
      }
    },
    openAllScreen() {
      this.allScreen = true;
      this.$nextTick(() => {
        var options = {
          // options 将在下一章中详细介绍
          container: 'xbgLawFullMind',
          shortcut: {
            enable: false
          },
          layout: {
            vspace: 10
          },
          view: {
            engine: 'canvas', // 思维导图各节点之间线条的绘制引擎
            hmargin: 50, // 思维导图距容器外框的最小水平距离
            vmargin: 50, // 思维导图距容器外框的最小垂直距离
            line_width: 1, // 思维导图线条的粗细
            line_color: '#50C1F9' // 思维导图线条的颜色
          } // [必选] 容器的ID，或者为容器的对象
        };
        var _jm = new jsMind(options);
        this.jMFullmodel = _jm;
        _jm.show(this.plumbJson);
      });
    },
    updateNode(nodeid, topic) {
      this.jMmodel.enable_edit();
      this.jMmodel.update_node(nodeid, topic);
      this.jMmodel.disable_edit();
    },
    appendNode(openModel, nodeid, topic, data) {
      this.jMmodel.enable_edit();
      this.jMmodel.add_node(openModel, nodeid, topic, data);
      this.jMmodel.disable_edit();
    },
    removeNode(openModel) {
      this.jMmodel.enable_edit();
      this.jMmodel.remove_node(openModel);
      this.jMmodel.disable_edit();
    },
    updateFullNode(nodeid, topic) {
      this.jMFullmodel.enable_edit();
      this.jMFullmodel.update_node(nodeid, topic);
      this.jMFullmodel.disable_edit();
    },
    appendFullNode(openModel, nodeid, topic, data) {
      this.jMFullmodel.enable_edit();
      this.jMFullmodel.add_node(openModel, nodeid, topic, data);
      this.jMFullmodel.disable_edit();
    },
    removeFullNode(openModel) {
      this.jMFullmodel.enable_edit();
      this.jMFullmodel.remove_node(openModel);
      this.jMFullmodel.disable_edit();
    },
    getCategary(clear) {
      this.$store.commit('LOADING', true);
      // this.topHitsSize = 15;
      clear ? (this.categories = []) : '';
      // const param = this.getParam();
      const param = {
        ...publicUtil.getLawParam({ categoryName: this.categoryName }),
        topHitsPage: this.topHitsPage - 1,
        topHitsSize: 15
      };
      // delete param.publishMachinery;
      param.category = this.listType;
      this.sortType ? (param.sortType = this.sortType) : '';
      this.sortField ? (param.sortField = this.sortField) : '';
      this.httpPost('law/search', param).then(data => {
        if (data && data.statusCode === usedLimitErrCode) {
          this.expiredModal = {
            show: true,
            limitType: data.data
          };
        }
        if (data && data.statusCode == 1) {
          this.categories = data.data.aggregations.category[0].f1.f1;
          this.totalPage = data.data.aggregations.category[0].f1.f0;
          this.categoryTotal = data.data.aggregations.category[0].f1.f3;
          this.categories.forEach(ele => {
            ele.f2 &&
              ele.f2.forEach(item => {
                this.$set(item, 'autoHeight', false);
                item.paragraphs.forEach((val, i) => {
                  this.$set(val, 'showContent', true);
                });
              });
            if (ele.f2 && ele.f2.length > 0) {
              this.$set(ele, 'title', ele.f2[0].title);
              this.$set(ele, 'status', ele.f2[0].status);
              this.$set(ele, 'level', ele.f2[0].level);
              this.$set(ele, 'docNum', ele.f2[0].docNum);
              this.$set(ele, 'pubTime', ele.f2[0].pubTime);
              this.$set(ele, 'execTime', ele.f2[0].execTime);
              this.$set(ele, 'collect_status', ele.f2[0].collect_status);
              this.$set(ele, 'classification', ele.f2[0].classification);
              this.$set(ele, 'category', ele.f2[0].category);
              this.$set(ele, 'cid', ele.f2[0].cid);
              this.$set(ele, 'publishMachinery', ele.f2[0].publishMachinery);
              this.$set(ele, 'expireTime', ele.f2[0].expireTime);
              let activeLawIdx = ele.f2.findIndex(o => o.show);
              if (activeLawIdx === -1) {
                activeLawIdx = 0;
              }
              this.$set(ele, 'activeLaw', ele.f2[activeLawIdx].id);
              if (activeLawIdx !== 0) {
                this.handleSameTab(ele);
              }
            }
          });
        }
        this.$store.commit('LOADING', false);
      });
    },
    sortRes(sortField, sortType, value) {
      this.sortField = sortField;
      this.sortType = sortType;
      this.sortValue = value;

      this.fetchData();
      if (this.showAll) this.getCategary();
    },
    showAllRes(category, index) {
      this.showAll = true;
      // this.sortField = '';
      // this.sortType = '';
      this.listType = category.f0;
      window.scrollTo(0, 0);
      this.getCategary();

      var paramObj = {
        // status: this.status,
        // pubYear: this.pubYear,
        // categoryName: this.categoryName,
        // level: this.levelName,
        // lawName: this.lawName,
        // // publishMachinery: this.publishMachinery,
        // section: this.section,
        // param: this.$route.query.param,
        category: category.f0
      };

      this.activeTab = `${category.f0}`;

      this.$router.push({
        path: '/law/home',
        query: paramObj
      });
    },
    openContent(paragraph) {
      paragraph.showContent = !paragraph.showContent;
    },
    backToList() {
      this.showAll = false;
      this.sortField = '';
      this.sortType = '';
      this.topHitsPage = 1;

      this.handleTab();
    },
    goDetail(col) {
      if (col.level == '法律') {
        this.openBlankPage('clause', {
          id: col.cid,
          param: col.title,
          lawName: col.lawName
        });
      } else if (col.cid) {
        this.openBlankPage('detail', {
          lawId: col.cid,
          param: this.$route.query.param
        });
      } else {
        console.log(col, 'empty cid');
      }
    },
    goAggDetail(col) {
      const activeLaw = col.activeLaw;
      const idx = col.f2.findIndex(i => i.id === activeLaw);
      if(col.f2[idx].paragraphLength > 1){
        this.openBlankPage('fulltext', {
          id: col.cid
        });
      }else {
        this.openBlankPage('detail', {
          lawId: col.cid,
          param: this.$route.query.param
        });
      }
    },
    openBlankPage(type, query = {}) {
      if (!query.id && !query.lawId) {
        console.error('暂无id，跳转失败');
        return;
      }
      window.sessionStorage.setItem('pageJump', true);
      const urlEnum = {
        fulltext: '/law/full/text',
        clause: '/law/clause',
        detail: '/law/detail'
      };
      const path = urlEnum[type];
      if (!path) {
        return;
      }
      let { href } = this.$router.resolve({
        path,
        query: query
      });
      if (projectInfoConfig.crossOriginIFrame) {
          window.location.href = href;
      } else {
          window.open(href, '_blank');
      }
    },
    // 移除已选条件
    deleteCondition(key) {
      if (this[key]) {
        this[key] = '';
      }

      var paramObj = {
        status: this.status,
        pubYear: this.pubYear,
        categoryName: this.categoryName,
        level: this.levelName,
        lawName: this.lawName,
        // publishMachinery: this.publishMachinery,
        section: this.section,
        param: this.$route.query.param
      };

      if (JSON.stringify(this.$route.query) != JSON.stringify(paramObj)) {
        this.$router.push({
          path: '/law/home',
          query: paramObj
        });
      }

      // this.fetchData(true)
    },
    getSelectData(data) {
      this.treeSectionList.forEach(i => {
        let arr = [];
        if (i.key === 'classification') {
          if (data.full_classification && data.full_classification.buckets) {
            arr = publicUtil.arrayToTree(data.full_classification.buckets).sort((a, b) => b.sort - a.sort);
          }
        } else if (i.key === 'collect_status') {
          if (data.collect_status && data.collect_status.buckets) {
            data.collect_status.buckets.forEach(v => {
              arr.push({
                name: v.key,
                value: v.key,
                doc_count: v.doc_count
              });
            });
          }
        }
        if (i.key === 'status') {
          if (data.status && data.status.buckets) {
            data.status.buckets.forEach(v => {
              arr.push({
                name: v.key,
                value: v.key,
                doc_count: v.doc_count
              });
            });
          }
        } else if (i.key === 'PubTime') {
          if (data.pubYear && data.pubYear.buckets) {
            data.pubYear.buckets.forEach(v => {
              arr.push({
                name: v.key + '年',
                value: v.key,
                doc_count: v.doc_count
              });
            });
          }
        } else if (i.key === 'category') {
          if (data.category) {
            data.category.forEach(v => {
              if (v.f1.f2) {
                arr.push({
                  name: v.f0,
                  value: v.f0,
                  sort: v.sort,
                  doc_count: v.f1.f3,
                  show: false,
                  level: v.f1.f2,
                  id: this.getCategoryId(0, v.f0),
                  children: v.f1.f2.buckets.map(i => {
                    return {
                      name: i.key,
                      doc_count: i.doc_count,
                      id: this.getCategoryId(1, v.f0)
                    };
                  })
                });
              }
            });
            arr = arr.filter(i => !['草案', '法规解读'].includes(i.name)).sort((a, b) => b.sort - a.sort);
          }
        }
        i.list = Object.freeze(arr);
      });
      this.publishMachineryNull = false;
    },
    handleSameTab(item) {
      var find = _.find(item.f2, { id: item.activeLaw });
      if (find) {
        item.title = find.title;
        item.status = find.status;
        item.level = find.level;
        item.docNum = find.docNum;
        item.pubTime = find.pubTime;
        item.publishMachinery = find.publishMachinery;
        item.execTime = find.execTime;
        item.cid = find.cid;
      }
    },
    // 点击重新查询
    setCondition(key, item) {
      const lawOptionFilterList = JSON.parse(sessionStorage.getItem('lawOptionFilterList')) || [];
      const curItem = lawOptionFilterList.find(curItem => key == curItem.key);
      if (curItem) {
        const { type, value } = curItem;
        if (type === 'string') {
          curItem.value = item.name;
        } else if (type === 'array') {
          curItem.value = [item.name];
        } else if (type === 'array-tree') {
          const val = { name: item.name, id: item.id };
          if (key === 'category') {
            val.type = item.level ? 'category' : 'level';
          }
          curItem.value = [val];
        } else if (type === 'date') {
          curItem.value = [`${item.value}-01-01`, `${item.value}-12-31`];
        }
      }
      sessionStorage.setItem('lawOptionFilterList', JSON.stringify(lawOptionFilterList));
      this.initConditionList();
      this.fetchData(true);
      this.backToList();
    },
    randomString(len) {
      len = len || 32;
      var $chars =
        'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = '';
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    scrollhandle() {
      // if($('html').scrollTop()>this.tabOffsetH){
      //     this.fixedTab = true
      // }else{
      //     this.fixedTab = false
      // }
      // const menuPosInfo = this.$refs.homeContainerRef.getBoundingClientRect();
      // this.menuFlag = menuPosInfo.y < 60;
    },
    checkJustTitle(params) {
      params = { ...params };

      if (params.topHitsPage !== 0 || params.topHitsSize !== 3) {
        return false;
      }

      const defaultKeys = ['clId', 'topHitsSize', 'topHitsPage'];
      defaultKeys.forEach(key => delete params[key]);
      if (Object.keys(params).length === 2 && params.title && params.search) {
        const allTitleSearch = params.search.every(item => item.f0 === '标题');
        return allTitleSearch;
      } else {
        return false;
      }
    },
    askCheckoutFulltext() {
      this.$message.warning('当前检索没有数据，正在为您智能切换。');
      setTimeout(() => {
        const filterObj = JSON.parse(sessionStorage.getItem('lawCaseFilterObj')) || {};
        filterObj.fulltext = filterObj.title;
        delete filterObj.title;
        filterObj.search = filterObj.search.map(item => {
          return { ...item, f0: '全文' };
        });
        sessionStorage.setItem('lawCaseFilterObj', JSON.stringify(filterObj));
        this.initConditionList();
        this.fetchData();
      }, 500);
    },
    async fetchData(load) {
      const param = {
        ...publicUtil.getLawParam(),
        topHitsPage: 0,
        topHitsSize: 3
      };
      // var param = this.getParam('fetch');
      if (!load) {
        this.$store.commit('LOADING', true);
      }
      // if ('fetch') {
      //   param.topHitsPage = 0
      // }
      // const justTitle = this.checkJustTitle(param);
      // param.topHitsSize = 3;
      this.sortType ? (param.sortType = this.sortType) : '';
      this.sortField ? (param.sortField = this.sortField) : '';
      this.showMind = false;
      await this.httpPost('law/search', param, load).then(data => {
        this.$store.commit('LOADING', false);
        this.isload = true;
        sessionStorage.removeItem('topHitsPage');
        if (data && data.statusCode === usedLimitErrCode) {
          this.expiredModal = {
            show: true,
            limitType: data.data
          };
        }
        if (data && data.statusCode == 1) {
          this.lawTotal = data.data.total;
          this.$nextTick(() => {
            this.tabOffsetH = $('.sticky-tab').offset() && $('.sticky-tab').offset().top;
            window.removeEventListener('scroll', this.scrollhandle);
            window.addEventListener('scroll', this.scrollhandle);
          });
          if (data.data.aggregations) {
            this.resultList = data.data.aggregations.category;
            // if (this.resultList.length === 0 && justTitle) {
            //     this.askCheckoutFulltext();
            // }
            this.getSelectData(data.data.aggregations);
            this.tabList = [];
            this.resultList &&
              this.resultList.forEach((v, i) => {
                if (!this.activeTab) {
                  this.activeTab = v.f0;
                }
                this.tabList.push({ label: v.f0, current: false });
                v.f1.f1.forEach(ele => {
                  ele.f2 &&
                    ele.f2.forEach(item => {
                      this.$set(item, 'autoHeight', false);
                      item.paragraphs.forEach((val, i) => {
                        this.$set(val, 'showContent', true);
                      });
                    });
                  if (ele.f2 && ele.f2.length > 0) {
                    this.$set(ele, 'title', ele.f2[0].title);
                    this.$set(ele, 'status', ele.f2[0].status);
                    this.$set(ele, 'level', ele.f2[0].level);
                    this.$set(ele, 'docNum', ele.f2[0].docNum);
                    this.$set(ele, 'pubTime', ele.f2[0].pubTime);
                    this.$set(ele, 'execTime', ele.f2[0].execTime);
                    this.$set(ele, 'collect_status', ele.f2[0].collect_status);
                    this.$set(ele, 'classification', ele.f2[0].classification);
                    this.$set(ele, 'category', ele.f2[0].category);
                    this.$set(ele, 'cid', ele.f2[0].cid);
                    this.$set(ele, 'publishMachinery', ele.f2[0].publishMachinery);
                    this.$set(ele, 'expireTime', ele.f2[0].expireTime);
                    let activeLawIdx = ele.f2.findIndex(o => o.show);
                    if (activeLawIdx === -1) {
                      activeLawIdx = 0;
                    }
                    this.$set(ele, 'activeLaw', ele.f2[activeLawIdx].id);
                    if (activeLawIdx !== 0) {
                      this.handleSameTab(ele);
                    }
                  }
                });
              });
            data.data.terms ? (this.terms = data.data.terms) : '';

            const activeTab = this.$route.query.activeTab;
            const hasTab = this.tabList.some(i => i.label === activeTab);
            // this.activeTab = hasTab ? activeTab : this.tabList[0].label
            this.activeTab = this.tabList && this.tabList[0].label;
            this.handleTab();
          }
          if (data.data.lawMap && data.data.lawMap.children && data.data.lawMap.children.length > 0) {
            this.showMind = true;
            var laws = arrayToTree(data.data.lawMap.children);
            laws.forEach((v, i) => {
              v.direction = 'right';
              i == 0 ? (v.expanded = true) : (v.expanded = false);
              v.children &&
                v.children.forEach(ele => {
                  ele.children &&
                    ele.children.forEach(val => {
                      val.children &&
                        val.children.forEach(element => {
                          element.children && (element.expanded = false);
                        });
                    });
                });
            });
            this.orginalLaws = JSON.parse(JSON.stringify(laws));
            this.plumbJson.data = {
              id: this.randomString(),
              topic: data.data.lawMap ? data.data.lawMap.keyword : '-',
              expanded: true,
              'background-color': '#3086FF',
              'foreground-color': '#fff',
              children: []
            };

            data.data.lawMap.count.forEach((v, i) => {
              if (!this.poistionBody[v.key]) {
                this.plumbJson.data.children.push({
                  id: v.key,
                  topic: `${v.key}(${v.value})`,
                  direction: 'left',
                  'background-color': i > this.colors.length - 1 ? this.colors[i - this.colors.length] : this.colors[i],
                  'foreground-color': '#fff'
                });
              } else {
                var item = {
                  id: v.key,
                  topic: `${v.key}(${v.value})`,
                  direction: 'right'
                };
                item['foreground-color'] = '#FFFFFF';
                item['background-color'] =
                  i > this.colors.length - 1 ? this.colors[i - this.colors.length] : this.colors[i];
                if (v.key == '法律') {
                  item.children = laws.splice(0, 4);
                  item['background-color'] = '#50C1F9';
                }
                this.plumbJson.data.children.push(item);
              }
            });
            var found = _.find(this.plumbJson.data.children, { id: '法律' });
            if (found && this.orginalLaws.length > 4) {
              found.children.push({
                'foreground-color': '#222222',
                topic: '展开<span class="el-icon-circle-plus-outline"></span>',
                'background-color': '#CCCCCC',
                id: '展开'
              });
            }

            this.$nextTick(() => {
              var options = {
                // options 将在下一章中详细介绍
                container: 'xbgLawMin',
                shortcut: {
                  enable: false
                },
                layout: {
                  vspace: 10
                },
                view: {
                  engine: 'canvas', // 思维导图各节点之间线条的绘制引擎
                  hmargin: 50, // 思维导图距容器外框的最小水平距离
                  vmargin: 50, // 思维导图距容器外框的最小垂直距离
                  line_width: 1, // 思维导图线条的粗细
                  line_color: '#50C1F9' // 思维导图线条的颜色
                } // [必选] 容器的ID，或者为容器的对象
              };
              var _jm = new jsMind(options);
              this.jMmodel = _jm;
              // _jm.show(this.plumbJson);
              _jm.show(this.removeHtmlTags(this.plumbJson));
            });
          } else {
            this.plumbJson.data = {
              id: this.randomString(),
              topic: data.data.lawMap ? data.data.lawMap.keyword : '-',
              expanded: true,
              'background-color': '#3086FF',
              'foreground-color': '#fff',
              children: []
            };
          }
        }
      });
      this.fetchReleaseSection(param);
    },
    removeHtmlTags(input) {
      if (typeof input === "string") {
        return input.replace(/<em>/g, "").replace(/<\/em>/g, "");
      } else if (typeof input === "object") {
        for (var key in input) {
          input[key] = this.removeHtmlTags(input[key]);
        }
      }
      return input;
    },
    // 发布机关
    async fetchReleaseSection(param) {
      const { data } = await this.httpPost('nlp/law/search/aggs', { ...param, agg_list: ['full_publishMachinery'] });
      if (data.full_publishMachinery.buckets || !data.full_publishMachinery.length) {
        this.publishMachineryNull = true;
        return;
      }
      const tree = publicUtil.arrayToTree(data.full_publishMachinery);
      const arr = [tree];
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].sort((a, b) => a.sort - b.sort);
        (arr[i] || []).forEach(item => {
          item.children && arr.push(item.children);
        });
      }
      const publishMachinery = this.treeSectionList.find(i => i.key === 'publishMachinery');
      publishMachinery.list = Object.freeze(tree);
    },
    sliceStr: sliceStr,
    setHighlight: setHighlight,
    removeSpace: removeSpace,
    showCases(item) {
      this.$router.push({
        path: '/law/case/list',
        query: {
          lawIds: item.id,
          name: item.name,
          key: this.searchKey
        }
      });
    },
    goLaw(item) {
      this.openBlankPage('clause', {
        id: item.id
      });
    },
    getCategoryId(level, name) {
      const treeList = publicUtil.treeToArray(JSON.parse(localStorage.getItem('category')));
      const item = treeList.find(i => {
        return i.level === level && name === i.keyAsString;
      });
      return item ? item.id : '';
    }
  },
  beforeDestroy() {
    window.removeEventListener('click', this.tapHandle);
    window.removeEventListener('scroll', this.pageScrollHandle);
    window.removeEventListener('scroll', this.scrollhandle);
  }
};
</script>
<style scoped lang="less">
/deep/ .el-tree-node__expand-icon.is-leaf {
  &.el-icon-caret-right:before {
    content: '•';
    color: #cccccc;
    font-size: 20px;
  }
}

/deep/ .el-tree-node {
  white-space: normal;
  .el-tree-node__content {
    height: auto !important;
    padding: 4px 0;
    align-items: center;
  }
}

/deep/ .tree-one {
  .el-tree-node__content {
    height: auto !important;
    padding: 0px 0;
    align-items: center;
  }
}

.head-warp {
  position: relative;
  .sort-wrap {
    // position: absolute;
    // z-index: 1000;
    right: 14px;
    top: 14px;
    color: #606266;
    .el-dropdown {
      color: #000;
    }
    /deep/ .el-dropdown-menu__item {
      color: #000;
    }
  }
  .case-search-condition-content {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    transition-duration: 0.3s;
    height: auto;
    line-height: 30px;
    background: #fff;
    .label {
      position: absolute;
      top: 0;
      left: 0;
    }
    &.is-put {
      height: 80px;
      overflow: hidden;
    }
  }
  .case-search-put {
    position: absolute;
    bottom: 0px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.11) 0%, #ffffff 100%);
    border-radius: 1px;
    filter: blur(0.5px);
    width: 100%;
    z-index: 10;
    height: 30px;
    line-height: 30px;
  }
  .put-text {
    cursor: pointer;
    color: #2c7ddc;
    position: absolute;
    bottom: 0px;
    font-size: 14px;
    width: 100%;
    z-index: 20;
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}

#xbgLawFullMind {
  width: 100%;
  height: calc(100vh - 60px);
}
.home-container {
  margin: 10px auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  // overflow-x: hidden;
  position: relative;

  .result-body {
    width: 960px;
    // flex: 1;
    // overflow-y: auto;
  }

  #xbgLawMin {
    width: 100%;
    height: 300px;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 1, 1);
    -webkit-transition: all 0.3s cubic-bezier(0.4, 0, 1, 1);
  }
  .hideOverMind #xbgLawMin {
    padding-top: 80px;
    height: 520px;
  }
}

.total-res {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(230, 230, 230, 1);
  padding-left: 32px;
  margin-bottom: 10px;

  p {
    padding: 14px 0;
  }
}

.look-more {
  color: #e42626;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}

.look-more:hover {
  background: #f5f5f5;
  border-radius: 4px;
}

.condition {
  padding-top: 10px;
  line-height: 26px;

  .condition-tag {
    display: inline-block;
    padding: 0px 10px;
    font-size: 14px;
    margin-right: 7px;
    margin-bottom: 10px;
    margin-top: 0;
    background: rgba(228, 38, 38, 0.12);
    color: @mainColor;
    border-radius: 3px;
    cursor: pointer;

    i {
      margin-left: 4px;
      // visibility: hidden;
    }
  }

  .condition-tag:hover {
    color: @mainColor;

    i {
      // visibility: inherit;
      cursor: pointer;
    }
  }

  .el-icon-plus {
    cursor: pointer;
  }

  .el-icon-plus:hover {
    color: @mainColor;
  }
}

.title-name:hover {
  color: @mainColor;
}

.law-title h3 {
  height: 26px;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  background: #d7e9ff;
  border-radius: 2px;
  color: #4a90e2;
  padding: 0 8px;
}

.law-title .title {
  font-size: 24px;
  color: @wordColor1;
  font-weight: bold;
  margin: 15px 0;
  line-height: 30px;
}

.law-title .title:hover {
  color: @mainColor;
  cursor: pointer;
}

.clearAll {
  cursor: pointer;
}

.clearAll:hover {
  color: @mainColor;
}

.law-title .desc {
  color: @wordColor1;
  line-height: 20px;
  margin-top: 10px;
}

.law-top {
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  margin: 0 30px;
}

.link-btn {
  width: 100%;
  margin-top: 20px;
  padding-bottom: 30px;
}

.link-btn .link {
  padding: 0 10px;
  height: 36px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  background: #fff;
  line-height: 32px;
  cursor: pointer;
}

.link-btn .link:hover {
  background: #e42626;
  color: #fff;
  border-color: #e42626;
}

.overflow-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.item-title {
  color: #507daf;
  line-height: 40px;
  margin-top: 15px;
  .name {
    font-size: 20px;
    font-weight: bold;
  }
}

.cate-list {
  padding: 20px 5px;
  cursor: pointer;
  position: relative;
  line-height: 20px;

  .title-name {
    margin-bottom: 2px;
    line-height: 26px;
    /deep/ em {
      font-weight: bold;
    }
  }
}

.sticky-tab {
  padding: 0 30px;
  line-height: 50px;
  height: 50px;
  overflow-y: hidden;
  position: sticky;
  background: #fff;
  top: 60px;
  z-index: 99;
  box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1);
  .move-transition {
    transform: translateY(-100%);
  }
  span {
    display: inline-block;
    padding: 0 20px;
    position: relative;
    cursor: pointer;
  }
  .sticky-icon {
    display: block;
    position: absolute;
    width: 24px;
    top: 12px;
    img {
      display: block;
      width: 100%;
    }
    .current {
      display: none;
    }
  }

  .sticky-icon:hover {
    cursor: pointer;
    .current {
      display: block;
    }
    .default {
      display: none;
    }
  }

  .sticky-left {
    left: 30px;
  }
  .sticky-right {
    right: 30px;
  }

  .cur-tab::after {
    content: '';
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 5px;
    width: 100%;
    background: #e42626;
  }
}

.load-more {
  margin: 0 15px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: @wordColor1;
  background: rgba(255, 255, 255, 1);
  border: 1px solid @lineColor;
  margin-top: 10px;
  cursor: pointer;
}

.law-detail-panel {
  margin: 5px 30px 0 30px;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 24px;
}

.law-header {
  display: flex;
  padding: 0 5px;
  height: 50px;
  line-height: 50px;
  justify-content: space-between;
}

.law-header h4 {
  font-size: 18px;
  color: @wordColor1;
  font-weight: bold;
}

.law-header span {
  color: #999;
  margin-left: 5px;
}

.title-name {
  font-size: 18px;
  line-height: 26px;
  color: @wordColor1;
}

.tag-status {
  height: 20px;
  background: #f5f5f5;
  border-radius: 2px;
  display: inline-block;
  font-size: 12px;
  color: #999999;
  padding: 0 6px;
  line-height: 20px;
}

.result-no-data {
  // position: absolute;
  width: 100%;
  background: #fff;
  height: 100vh;
  text-align: center;
  // top: 0px;
  box-sizing: border-box;
  border: 1px solid @lineColor;
  border-top: none;
}

.result-no-data img {
  width: 280px;
  display: block;
  margin: 0 auto;
  margin-top: 165px;
}

.xbg-relation-company-search {
  padding: 0 30px;
  background: #fff;
  box-sizing: border-box;
  margin-top: 10px;
  border: 1px solid rgba(230, 230, 230, 1);

  h4 {
    color: #222;
    font-size: 22px;
    margin: 26px 0 10px 0;
    font-weight: bold;
  }

  .radius {
    width: 8px;
    height: 8px;
    min-width: 8px;
    background: rgba(204, 204, 204, 1);
    display: inline-block;
    border-radius: 8px;
    margin-top: 5px;
    margin-right: 5px;
  }

  .xbg-relation-company-ul {
    padding-bottom: 30px;
    line-height: 22px;
  }

  .xbg-relation-company-li {
    margin-top: 10px;
    width: 49%;
    display: inline-block;
  }

  .xbg-relation-company-li:hover {
    color: @mainColor;
    cursor: pointer;
  }
}

.all-result {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  padding: 0 30px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1);
  position: sticky;
  top: 60px;
  z-index: 99;
  .all-result-left {
    display: flex;
    .back {
      font-weight: bold;
      cursor: pointer;
    }
    .back-icon {
      width: 26px;
      margin-right: 10px;
      margin-bottom: 4px;
      cursor: pointer;
    }

    .cur-back-icon {
      width: 26px;
      margin-right: 10px;
      margin-bottom: 4px;
      display: none;
      cursor: pointer;
    }
  }
  .all-result-left:hover {
    .back-icon {
      display: none;
    }

    .back-to {
      color: #e42626;
    }

    .cur-back-icon {
      display: inline-block;
    }
  }
  .all-result-right {
    .sort {
      color: #666;
    }
  }
}

.all-list {
  padding: 0 30px;
  &-item {
    margin: 40px 0;
    cursor: pointer;
    .info-bar {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
}
.search-panel-content {
  background: rgba(245, 245, 245, 1);
  padding-bottom: 10px;
}

.is-law {
  margin-top: 10px;
  border-radius: 8px;
  padding: 10px 20px 10px 20px;
  max-height: 300px;
  overflow-y: auto;
  .paragraph-head {
    display: flex;
    justify-content: space-between;
    .paragraph-head-icon {
      cursor: pointer;
      padding: 0 5px 0 20px;
      color: #4a90e2;
      span {
        font-size: 14px;
      }
    }
  }
  .paragraph-name {
    line-height: 20px;
  }
  .paragraph-desc {
    line-height: 20px;
    cursor: pointer;
  }
}

.fixed-bottom-show {
  position: absolute;
  bottom: 0;
  left: 5px;
  height: 40px;
  background: rgba(245, 245, 245, 1);
  z-index: 999;
  width: calc(100% - 10px);
  border-radius: 0 0 10px 10px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  span {
    color: #4a90e2;
    margin: 0 20px;
  }
}
.fixed-bottom-show:hover {
  background: #e6e6e6;
}

.knowledge {
  background: #fff;
  margin-bottom: 10px;
  border: 1px solid rgba(230, 230, 230, 1);
  position: relative;
  overflow: hidden;
  .knowledge-top {
    display: flex;
    justify-content: space-between;
    a {
      margin-right: 40px;
      cursor: pointer;
    }
  }
  .title {
    position: absolute;
    padding: 20px 26px;
    font-size: 18px;
    width: 100%;
    top: 0;
    z-index: 99;
    left: 0;
    color: #222;
    background: rgba(255, 255, 255, 0.9);
  }

  .open-all {
    cursor: pointer;
    position: absolute;
    padding: 20px 26px;
    width: 100%;
    bottom: 0;
    z-index: 99;
    left: 0;
    color: #222;
    text-align: center;
    background: linear-gradient(180deg, rgba(251, 251, 251, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }
}

.search-panel {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(230, 230, 230, 1);
  .timeline {
    display: inline-block;
    height: 20px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(80, 125, 175, 1);
    padding: 0 5px;
    line-height: 20px;
    color: #507daf;
    margin-left: 5px;
    margin-bottom: 5px;
    &.collect_status {
      color: #10b0ca;
      border: 1px solid #10b0ca;
    }
  }
  .title {
    padding: 14px 30px;
    font-size: 18px;
    color: #222;
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    .tip {
      color: #999;
    }
    .sort {
      color: #666;
    }
  }

  .xbg-subject {
    background: #fff;
    border: 1px solid rgba(230, 230, 230, 1);
    border-radius: 4px;
    margin: 0 30px;
    overflow: auto;
  }

  .search-panel-top {
    font-size: 22px;
    color: #222;
    border-bottom: 1px solid #e6e6e6;
    padding: 26px 0 18px 0;
    font-weight: bold;
  }

  .search-panel-list {
    padding: 20px 0;

    .model-title {
      color: #4a90e2;
      font-size: 18px;
      margin-top: 15px;
      font-weight: bold;
      margin-bottom: 14px;
    }

    .search-panel-list-item {
      padding: 20px 0;
    }

    .search-panel-list-item:hover {
      background: #fafafa;
      cursor: pointer;
    }

    .search-panel-title {
      margin-bottom: 10px;

      span {
        font-weight: bold;
      }
    }

    .search-panel-content {
      color: #666;
      line-height: 20px;
    }
  }

  .paginate-bar {
    padding: 30px 0;
    margin-left: -5px;
  }
}

.the-paragraph {
  border-bottom: 1px dashed #cccccc;
  padding: 12px 0;
}
.paragraph-desc {
  // padding: 10px 0;
  cursor: pointer;
}
.menu {
  position: sticky;
  top: 70px;
  width: 250px;
  // min-width: 250px;
  margin-left: 10px;
  margin-right: 0;
  background: rgba(255, 255, 255, 1);
  border: 1px solid @lineColor;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 130px);
  z-index: 99;
  .tree-item {
    margin-bottom: 5px;

    .filter-tree-head {
      background: #f7f7f7;
      padding: 0 10px;
      display: flex;
      line-height: 40px;
      justify-content: space-between;
      cursor: pointer;

      p {
        font-weight: bold;
        color: #222;
      }

      span {
        color: #666;
      }
    }
    .show-more {
      color: #666;
      cursor: pointer;
      text-align: center;
      line-height: 20px;
      margin: 0 10px;
      span {
        display: block;
      }
      .open-tip a {
        display: none;
      }
      .open-tip:hover i {
        display: none;
      }
      .open-tip:hover a {
        display: block;
        color: @mainColor;
      }
    }

    .level-one {
      padding: 15px;
      color: #212731;

      ul li {
        margin-bottom: 10px;
        display: flex;
        line-height: 20px;
        cursor: pointer;
      }

      .radius {
        width: 6px;
        height: 6px;
        min-width: 6px;
        display: block;
        background: rgba(204, 204, 204, 1);
        border-radius: 6px;
        margin-right: 10px;
        margin-top: 5px;
      }
    }

    .level-two {
      padding: 10px;
      // width:100px;
      color: #212731;

      ul li {
        margin-bottom: 10px;
        line-height: 20px;
        cursor: pointer;
      }

      .firstName {
        display: flex;

        span i {
          transition: all ease 0.2s;
        }
      }

      .lawName {
        color: #212731;
        padding-left: 18px;
        line-height: 24px;
        display: flex;
      }

      .radius {
        width: 6px;
        height: 6px;
        min-width: 6px;
        display: block;
        background: rgba(204, 204, 204, 1);
        border-radius: 6px;
        margin-right: 10px;
        margin-top: 7px;
      }
    }
  }
}
</style>

<style lang="less">
.law-detail-panel .el-tabs__nav-wrap {
  background: #fff;
}

.knowledge-dialog .el-dialog__body {
  padding: 0 !important;
}

.paginate-bar .el-pager,
.paginate-bar .el-pagination {
  padding-left: 0;
}

.el-tabs__nav-next,
.el-tabs__nav-prev {
  padding: 3px 5px;
}

.search-panel-content .editor-content {
  line-height: 22px !important;
}

.search-panel-list-item .status-bar {
  margin-top: 5px !important;
}

// .search-panel-content br {
//     display: none;
// }

.samelaw-tab {
  margin-top: 10px;
  margin-bottom: -10px;
  .el-tabs__header {
    margin: 0;
    background: #f5f5f5;
  }
}

.sticky-tab .el-tabs__nav-next i,
.sticky-tab .el-tabs__nav-prev i {
  display: none;
}

.sticky-tab .el-tabs__nav-prev {
  background: url('../../assets/default-more-left.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 24px;
  display: inline-block;
  height: 24px;
  z-index: 99;
}

.sticky-tab .el-tabs__nav-next {
  background: url('../../assets/default-more-right.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 24px;
  display: inline-block;
  height: 24px;
  z-index: 99;
}

.sticky-tab .el-tabs__nav-prev:hover {
  background: url('../../assets/more-left.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.sticky-tab .el-tabs__nav-next:hover {
  background: url('../../assets/more-right.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.sticky-tab .el-tabs__nav-next,
.sticky-tab .el-tabs__nav-prev {
  &.is-disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  &.el-tabs__nav-prev {
    background-image: url('../../assets/default-more-left.png');
  }
  &.el-tabs__nav-next {
    background-image: url('../../assets/default-more-right.png');
  }
}

.sticky-tab .el-tabs__nav-scroll {
  margin: 0 10px;
}

jmnode {
  box-shadow: none !important;
  font-size: 14px !important;
  border-radius: 20px !important;
  height: 30px !important;
  padding: 0 12px !important;
  line-height: 30px !important;
  cursor: pointer !important;
}

jmnode.root {
  font-size: 14px !important;
}

jmnode em {
  color: #fff !important;
}

jmexpander {
  width: 12px !important;
  height: 12px !important;
  border-color: #50c1f9 !important;
  color: #50c1f9 !important;
  cursor: inherit !important;
}

.knowledge {
  .jsmind-inner {
    overflow: hidden;
  }
}

.knowledge.hideOverMind {
  .jsmind-inner {
    overflow: auto !important;
  }
}

.knowledge-dialog .el-dialog__headerbtn {
  font-size: 24px;
}

em {
  color: #f86359 !important;
  font-style: normal;
}

.samelaw-tab .el-tabs__item {
  color: #999 !important;
}

.samelaw-tab .el-tabs__item.is-active {
  color: #e42626 !important;
  font-size: 14px;
}

.samelaw-tab .el-tabs__nav-wrap::after {
  background: #e6e6e6;
  height: 1px;
}

.samelaw-tab .el-tabs__active-bar {
  height: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/law/law.vue